import React from 'react';
import { useLanguage } from './LanguageContext';
import { motion } from 'framer-motion';
export function Booking() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-teal-700 relative overflow-hidden" data-id="element-56">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-57">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" data-id="element-58"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-x-1/2 translate-y-1/2" data-id="element-59"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-60">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-serif font-medium text-white mb-6" data-id="element-61">
          {t.booking.title}
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-teal-50 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-62">
          {t.booking.text}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-63">
          <a href="#contact" className="w-full sm:w-auto bg-white text-teal-700 hover:bg-teal-50 px-8 py-4 rounded-full text-base font-semibold transition-colors shadow-lg" data-id="element-64">
            {t.booking.btnBook}
          </a>
          <a href="#contact" className="w-full sm:w-auto bg-teal-600 text-white hover:bg-teal-500 border border-teal-500 px-8 py-4 rounded-full text-base font-medium transition-colors" data-id="element-65">
            {t.booking.btnContact}
          </a>
        </motion.div>
      </div>
    </section>;
}